import FuseResult = Fuse.FuseResult;
import { UseList } from "./types";
import { useTranslation } from "react-i18next";
import _, { filter, get, map } from "lodash/fp";
import { useVenues } from "../match";
import React, { useCallback, useMemo } from "react";
import Fuse from "fuse.js";
import { IonItem } from "@ionic/react";
import { autocompleteItemStyle } from "./autocompleteStyles";

export const useVenueList: () => UseList<string[]> = () => {
    const { t } = useTranslation();
    const getResultsFromFuse = map<FuseResult<string>, string>(get("item"));

    const venues = useVenues();

    const fuse = useMemo(
        () =>
            new Fuse<string>(venues, {
                threshold: 0.2,
                findAllMatches: false,
                ignoreLocation: true,
                shouldSort: true,
            }),

        [venues]
    );

    const cb = useCallback(
        (query: string = "") => {
            if (query === "") {
                return venues;
            }
            const res = getResultsFromFuse(fuse?.search(query, { limit: 50 }));
            const removeExactMatch: (l: string[]) => string[] = filter(
                (x) => x !== query
            );
            return removeExactMatch(res);
        },
        [fuse, getResultsFromFuse, venues]
    );

    return useMemo(
        () => ({
            search: cb,
            renderer: venueListRenderer(t),
        }),
        [cb, t]
    );
};
export const venueListRenderer =
    (t: any) => (results: string[], save: (v: string) => void) => {
        const orderByValue = _.orderBy<string>((x) => x, ["asc"]);
        // No "no results" placeholder: when nothing matches, the modal's
        // free-text ("Use ...") row already covers what the user needs to do.
        return orderByValue(results).map((result, index) => {
            return (
                <IonItem
                    key={`${index}-${result}`}
                    onClick={() => save(result)}
                    style={autocompleteItemStyle}
                >
                    {result}
                </IonItem>
            );
        });
    };
